import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-html-tooltip',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
    class="tooltip-container"
    [class.large-content]="htmlContent.length > 500"
    [style.left.px]="left"
    [style.top.px]="top">
      <div [innerHTML]="htmlContent"></div>
    </div>
  `,
  styleUrls: ['./html-tooltip.component.scss']
})
export class HtmlTooltipComponent {
  @Input() htmlContent: string = '';
  @Input() top: number = 0;
  @Input() left: number = 0;
}
